import styled from "styled-components";

import DeepleButton from "components/Button";

export const Button = styled(DeepleButton)`
  max-width: initial;
  border-radius: 5px;
`;
